var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderCompletedActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 22.25L16.45 20.1C16.2667 19.9167 16.0333 19.825 15.75 19.825C15.4667 19.825 15.2333 19.9167 15.05 20.1C14.8667 20.2833 14.775 20.5167 14.775 20.8C14.775 21.0833 14.8667 21.3167 15.05 21.5L17.9 24.35C18.1 24.55 18.3333 24.65 18.6 24.65C18.8667 24.65 19.1 24.55 19.3 24.35L24.95 18.7C25.1333 18.5167 25.225 18.2833 25.225 18C25.225 17.7167 25.1333 17.4833 24.95 17.3C24.7667 17.1167 24.5333 17.025 24.25 17.025C23.9667 17.025 23.7333 17.1167 23.55 17.3L18.6 22.25ZM13 28H27V14H13V28ZM13 30C12.45 30 11.9792 29.8042 11.5875 29.4125C11.1958 29.0208 11 28.55 11 28V14C11 13.45 11.1958 12.9792 11.5875 12.5875C11.9792 12.1958 12.45 12 13 12H17.2C17.4167 11.4 17.7792 10.9167 18.2875 10.55C18.7958 10.1833 19.3667 10 20 10C20.6333 10 21.2042 10.1833 21.7125 10.55C22.2208 10.9167 22.5833 11.4 22.8 12H27C27.55 12 28.0208 12.1958 28.4125 12.5875C28.8042 12.9792 29 13.45 29 14V28C29 28.55 28.8042 29.0208 28.4125 29.4125C28.0208 29.8042 27.55 30 27 30H13ZM20 13.25C20.2167 13.25 20.3958 13.1792 20.5375 13.0375C20.6792 12.8958 20.75 12.7167 20.75 12.5C20.75 12.2833 20.6792 12.1042 20.5375 11.9625C20.3958 11.8208 20.2167 11.75 20 11.75C19.7833 11.75 19.6042 11.8208 19.4625 11.9625C19.3208 12.1042 19.25 12.2833 19.25 12.5C19.25 12.7167 19.3208 12.8958 19.4625 13.0375C19.6042 13.1792 19.7833 13.25 20 13.25Z",
    fill: "url(#paint0_linear_496_252414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_252414",
    x1: 11,
    y1: 10,
    x2: 29.3084,
    y2: 10.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCompletedActive);
export default __webpack_public_path__ + "static/media/OrderCompletedActive.37a76c1178aff1a2a0e1bb0f8ff646cd.svg";
export { ForwardRef as ReactComponent };